import { UscgGroupBM } from 'src/types/BusinessModel/Stowage/Product/UscgGroupBM';
import { UscgGroup } from 'src/types/ViewModel/Stowage/Product/UscgGroup';

export const createUscgGroup = (uscgGroupBM: UscgGroupBM): UscgGroup => {
    return {
        id: uscgGroupBM.id,
        number: uscgGroupBM.number,
        name: uscgGroupBM?.name,
    };
};
